import gql from 'graphql-tag'

export const UserFragment = gql`
  fragment User on user {
    id
    created_at
    updated_at
    name
    email
    customer_account_id
    role
    preferences
    firstname
    lastname
  }
`

export const WebFormFragment = gql`
  fragment WebForm on web_form {
    id
    created_at
    updated_at
    reference
    type
    form_data
    user_id
    customer_account_id
    is_submitted
    submitted_at
    status
    sales_order_id
    file_id
    quantity
    comments
    item_id
    web_form_files {
      file_id
      file {
        id
        file_name
        file_size
        file_content_type
        uploaded_at
      }
    }
  }
`

export const CustomerFragment = gql`
  fragment Customer on account {
    id
    company_name
    vat_number
    number
  }
`

export const SupplierFragment = gql`
  fragment Supplier on supplier {
    id
    created_at
    updated_at
    legal_name
    vat_number
    primary_email
    primary_phone
    billing_address_id
    number
  }
`

export const AddressFragment = gql`
  fragment Address on address {
    attn
    company_name
    state
    street
    number
    zipcode
    city
    country_code
    country_name
    line1
    email
    is_default
    is_shipping_address
    phone
    rating
    id
    is_archived
    created_at
    updated_at
  }
`

export const CustomerAddressFragment = gql`
  fragment CustomerAddress on customer_address {
    customer_id
    address_id
    is_active
    alias
    updated_at
    created_at
  }
`

export const JsonFormFragment = gql`
  fragment JsonForm on json_form {
    id
    name
    schema
    ui_schema
    updated_at
    created_at
  }
`

export const ProductSalesPriceAuditFragment = gql`
  fragment ProductSalesPriceAudit on product_sales_price_audit {
    id
    product_id
    sales_price_before
    sales_price_after
    user_id
    updated_at
    created_at
  }
`

export const ItemFragment = gql`
  fragment Item on item {
    id
    created_at
    updated_at
    code
    short_description
    extra_description
    webshop_custom_form
    is_sales_item
    latest_sales_price
    web_shop_allow_grouping
  }
`

export const ItemGroupFragment = gql`
  fragment ItemGroup on item_group {
    id
    code
    description
    updated_at
    created_at
  }
`
export const ProductMaterialFragment = gql`
  fragment ProductMaterial on product_material {
    product_id
    material_id
    quantity
    updated_at
    created_at
  }
`

export const ProductJsonFormFragment = gql`
  fragment ProductJsonForm on product_json_form {
    product_id
    json_form_id
    index
    updated_at
    created_at
  }
`

export const ProductFileFragment = gql`
  fragment ProductFile on product_file {
    product_id
    file_id
    updated_at
    created_at
  }
`

export const ShopFragment = gql`
  fragment Shop on shop {
    id
    name
    is_active
    created_at
    updated_at
  }
`

export const FileFragment = gql`
  fragment File on file_uploads {
    id
    created_at
    updated_at
    file_name
    file_size
    file_content_type
    key
    bucket_name
    user_id
    uploaded_at
    is_temporary
  }
`

export const I18nTranslationFragment = gql`
  fragment I18nTranslation on i18n_translation {
    key
    locale
    translation
    created_at
    updated_at
  }
`

export const AttributeFragment = gql`
  fragment Attribute on attribute {
    id
    key
    options
    type
    created_at
    updated_at
  }
`

export const CartItemFragment = gql`
  fragment CartItem on cart_item {
    id
    created_at
    updated_at
    user_id
    customer_id
    product_id
    quantity
    reference
    file_id
    shipping_address_id
    comments
    specifications
  }
`

export const WebOrderFragment = gql`
  fragment WebOrder on web_order {
    id
    created_at
    updated_at
    number
    user_id
    customer_id
    shipping_address_id
    reference
    comments
    status
  }
`

export const WebOrderItemFragment = gql`
  fragment WebOrderItem on web_order_item {
    id
    created_at
    updated_at
    product_id
    quantity
    reference
    file_id
    comments
    specifications
    web_order_id
  }
`
